import { FloatString, IntString, Nullable } from './commonTypes';
import {
  RolePerformerType,
  SessionEstimateItemUnitType,
  TCommercialId,
  TRoleId,
  Usage,
  UsageCycleNumber,
  UsageCycleUnit,
  UsageType,
  UsageUnitType,
} from '@talon/web/lib/api';

export type TWorkTimeTotals = { straightHours: number; overtimeHours: number };

/**
 * Session Estimates
 */

export type TSessionEstimateForm = {
  title: string;
  date: Nullable<Date>;
};

export type TSessionEstimateItemForm = {
  title: string;
  units: FloatString;
  unitType: SessionEstimateItemUnitType;
  rate: FloatString;
  taxesMultiplier: FloatString;
  handlingMultiplier: FloatString;
  pAndHMultiplier: FloatString;
  [key: string]: string | FloatString | SessionEstimateItemUnitType;
};

/**
 * Usage Estimates
 */

export type TUsageEstimateForm = {
  title: string;
};

export type TUsageEstimateItemForm = {
  title: string;
  roleId: TRoleId;
  performerType?: RolePerformerType;
  type?: UsageType;
  units: FloatString;
  unitType?: UsageUnitType;
  cycles: IntString;
  cycleNumber?: UsageCycleNumber;
  cycleUnit?: UsageCycleUnit;
  rate: FloatString;
  taxesMultiplier: FloatString;
  handlingMultiplier: FloatString;
  pAndHMultiplier: FloatString;
  [key: string]: string | FloatString | IntString | UsageUnitType | UsageCycleNumber | Usage | TCommercialId | TRoleId | undefined;
};
